import React, { useState } from 'react'

import { Format } from 'services/Dates'
import { getPositionName, getProjectName } from 'services/Utilities'
import flagsPermissionsHandler from 'services/schedule/flagsPermissionsHandler'
import { t } from 'translations'

const EmployeeSelectionToolIssues = ({ user: { flags }, alreadyInTemplate, isMulti }) => {
  const [viewMore, setViewMore] = useState(false)
  const isEligible = Object.values(flags.dateFlags).every(({ isEligible }) => isEligible)
  const datesWithIssues = Object.keys(flags.dateFlags).filter(date => {
    return !flags.dateFlags[date].isEligible
  })

  return (
    <>
      <div className={`mr-1 ${isEligible ? 'text-success' : 'text-danger'}`}>
        {t(`manager.scheduleTemplates.employeeSelectionTool.${isEligible ? 'ELIGIBLE' : 'NOT_ELIGIBLE'}`)}
      </div>
      {/* Warn if user is already in template */}
      {alreadyInTemplate.length ? (
        <div className="font-italic text-warning">
          {t(`manager.scheduleTemplates.employeeSelectionTool.${!isMulti ? 'ALREADY_IN' : 'ALREADY_IN_MULTI'}`, {
            days: alreadyInTemplate.join(','),
            count: alreadyInTemplate.length
          })}
        </div>
      ) : (
        ''
      )}
      {flags.otherFlags.lockedToCurrent ? (
        <div className="font-italic">{t('manager.scheduleTemplates.employeeSelectionTool.LOCKED_TO_CURRENT_PROJECT')}</div>
      ) : null}
      {flags.otherFlags.preferredCurrent ? (
        <div className="font-italic">{t('manager.scheduleTemplates.employeeSelectionTool.PREFERRED_CURRENT_PROJECT')}</div>
      ) : null}
      {flags.otherFlags.preferredOtherProj ? (
        <div className="font-italic">{t('manager.scheduleTemplates.employeeSelectionTool.PREFERRED_OTHER_PROJECT')}</div>
      ) : null}
      {!isEligible && (flags.otherFlags || flags.shiftFlags) ? (
        <>
          {flags.otherFlags.employeeTypeInvalid ? (
            <div className="text-warning">{t('manager.scheduleTemplates.employeeSelectionTool.INVALID_EMPLOYEE_TYPE')}</div>
          ) : null}
          {flags.otherFlags.lockedToOtherProj ? (
            <div className="text-warning">{t('manager.scheduleTemplates.employeeSelectionTool.LOCKED_TO_OTHER_PROJECT')}</div>
          ) : null}
        </>
      ) : null}
      {datesWithIssues.map((date, index) => {
        // If viewMore is not active, do not show more than 3 issues
        if (!viewMore && index > 2) return null

        const dateFlags = flags.dateFlags[date]

        const mainFlags = Object.keys(dateFlags)
          .filter(flag => !['reasons', 'isEligible', 'unavailableAllDay', 'unavailableOverlap', 'eventOverlapping'].includes(flag))
          .map(flag => t(`manager.schedule.EDIT_MODAL.USER_FLAGS_SHORT.${flagsPermissionsHandler(flag)}`))
          .join(', ')

        const availabilityFlags = (
          <>
            {dateFlags.unavailableAllDay ? <span>{t('manager.scheduleTemplates.employeeSelectionTool.UNAVAILABLE')}</span> : null}
            {(dateFlags.reasons.availabilities || [])
              .map(({ type, start, end }) => t(`manager.scheduleTemplates.employeeSelectionTool.${type}_RANGE`, { start, end }))
              .join(', ')}
          </>
        )

        const eventFlags = (dateFlags.reasons.shiftsOverlapping || [])
          .map(({ start, end, positionId, projectId }) =>
            t(`manager.scheduleTemplates.employeeSelectionTool.EVENT_OVERLAPPING${projectId ? '_PROJECT' : ''}`, {
              start: Format(start, { outFormat: 'time' }),
              end: Format(end, { outFormat: 'time' }),
              positionName: getPositionName(positionId),
              projectName: getProjectName(projectId, { canBeNull: true, noValue: '' })
            })
          )
          .join(', ')

        return (
          <div key={date} className="mt-2">
            <b>{Format(date, { inFormat: 'flagDate', outFormat: 'humanDate' })}</b>
            <div className="text-warning">
              <div>{eventFlags}</div>
              <div>{availabilityFlags}</div>
              <div>{mainFlags}</div>
            </div>
          </div>
        )
      })}
      {datesWithIssues.length > 3 ? (
        <div className="mb-3 text-underline cursor-pointer" onClick={() => setViewMore(!viewMore)}>
          {t(`manager.scheduleTemplates.employeeSelectionTool.${viewMore ? 'VIEW_LESS' : 'VIEW_MORE'}`, { count: datesWithIssues.length - 3 })}
        </div>
      ) : null}
    </>
  )
}

export default EmployeeSelectionToolIssues
